// extracted by mini-css-extract-plugin
module.exports = {"icono-wrapper":"configurations_icono-wrapper__HG8l3","icono":"configurations_icono__ek9Vt"};